export const createCombinedLabelAndValue = (entry1, entry2) => {
    const { label: label1, formattedValue: value1 } = entry1;
    const { label: label2, formattedValue: value2 } = entry2;
    const firstSet = Boolean(label1 && value1);
    const firstLabel = firstSet ? label1 : '';
    const firstValue = firstSet ? value1 : '';
    const secondSet = Boolean(label2 && value2);
    const secondLabel = secondSet ? label2 : '';
    const secondValue = secondSet ? value2 : '';
    const delimiter = firstSet && secondSet ? '/' : '';
    const title = `${firstLabel}${delimiter}${secondLabel}`;
    const value = `${firstValue}${delimiter}${secondValue}`;
    return {
        key: title,
        item: { label: title, formattedValue: value },
    };
};
export const createSingleLabelValue = (entry) => {
    const { label, formattedValue } = entry;
    const isSet = Boolean(label && formattedValue);
    const computedLabel = isSet ? label : '';
    const title = `${computedLabel}`;
    return {
        key: title,
        item: { label, formattedValue: formattedValue !== null && formattedValue !== void 0 ? formattedValue : '' },
    };
};
export const createSingleLabelValueWithRemark = ({ label, formattedValue, remarks, }) => {
    const isSet = Boolean(label && formattedValue);
    const computedLabel = isSet ? label : '';
    const title = computedLabel;
    return {
        key: title,
        item: { label: title, formattedValue: formattedValue !== null && formattedValue !== void 0 ? formattedValue : '', remarks },
    };
};
